import { render } from "./CardForm.vue?vue&type=template&id=5ed8cc06&scoped=true"
import script from "./CardForm.vue?vue&type=script&lang=js"
export * from "./CardForm.vue?vue&type=script&lang=js"

import "./CardForm.vue?vue&type=style&index=0&id=5ed8cc06&lang=scss&scoped=true"

import exportComponent from "/Users/amina/Desktop/streamup_amina/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed8cc06"]])

export default __exports__